// @flow
import * as React from 'react'
import Toggle from 'ui/atoms/Toggle'

import BaseField from './BaseField'

type Props = {
  onChange?: (event: SyntheticInputEvent<HTMLInputElement>) => mixed,
  iconChecked?: React.Node,
  iconUnchecked?: React.Node,
  primaryIdle?: boolean,
  compact?: boolean,
  horizontal?: boolean,
  label: string,
  lightLabel?: boolean,
  smallLabel?: boolean,
  reverse?: boolean,
  grayOutWhenDisabled?: boolean,
  disabled?: boolean,
  primary?: boolean,
  value: boolean,
}
function ToggleField({
  compact,
  horizontal,
  label,
  lightLabel,
  reverse,
  smallLabel,
  grayOutWhenDisabled,
  ...rest
}: Props): React.Node {
  return (
    <BaseField
      compact={compact}
      horizontal={horizontal}
      label={label}
      mutedLabel={grayOutWhenDisabled && rest.disabled}
      reverse={reverse}
      semibold={!lightLabel}
      smallLabel={smallLabel}
    >
      <Toggle {...rest} />
    </BaseField>
  )
}

export default ToggleField
